export default __webpack_public_path__ + "static/desk09-cfbfe71a83dfea594be82d6a00ac7178.png";